import { useMemo } from 'react';
import { Field, ImageField, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import { getSharedProperty, useBreakpoint } from '@gn-audio/jss-components';

import { ComponentProps } from 'lib/component-props';

type SingleImageSpotRendering = {
  fields: SingleImageSpotFields;
};

export type SingleImageSpotFields = {
  desktopImage: ImageField;
  desktopImageShared: ImageField;
  mobileImage: ImageField;
  mobileImageShared: ImageField;
  isFullWidth: Field<boolean>;
  backgroundColor: Field<string>;
};

type SingleImageSpotProps = {
  rendering: SingleImageSpotRendering;
} & ComponentProps;

const SingleImageSpot = ({ rendering: { fields } }: SingleImageSpotProps) => {
  const desktopImage = getSharedProperty(fields, 'desktopImage')?.value;
  const mobileImage = getSharedProperty(fields, 'mobileImage')?.value ?? desktopImage;

  const { isAboveXxs } = useBreakpoint('xxs', true);

  const image = useMemo(() => {
    return isAboveXxs ? desktopImage : mobileImage;
  }, [isAboveXxs, mobileImage, desktopImage]);

  const isFullWidth = fields.isFullWidth?.value;
  const containerClass = isFullWidth ? 'container-fluid' : 'container';
  const borderRadiusClass = isFullWidth ? 'rounded-none' : 'rounded-2xl overflow-hidden';

  const backgroundColorStyle = { background: fields.backgroundColor?.value || 'transparent' };
  return (
    <div style={backgroundColorStyle}>
      <div className={classNames('flex justify-center', containerClass)}>
        <img className={borderRadiusClass} src={image?.src} alt={image?.alt as string} />
      </div>
    </div>
  );
};

export default withDatasourceCheck()(SingleImageSpot);
